/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../gql/graphql';

import type { PaymentBreakdownFragmentFragment, PaymentLineFragmentFragment } from '../payments/fragment.generated';
import type { MoneyFieldsFragment } from '../generic/fragment.generated';
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type MoneyInput = {
  /** The numerical amount. */
  amount: string;
  /** The ISO-421 3-letter currency code. */
  currency: string;
};

/** An enumeration. */
export type PaymentLineKind =
  | 'CREATOR_NET'
  | 'INVOICE_TOTAL'
  | 'PAYER_WITHHOLDING'
  | 'PROVIDER_FEE'
  | 'RETENTION'
  | 'SERVICE_FEE'
  | 'SUBTOTAL'
  | 'TOTAL'
  | 'VAT';

/** An enumeration. */
export type PaymentLineRole =
  | 'LINE'
  | 'SUBTOTAL'
  | 'TOTAL';

/**
 * One creator's net amount for `TaxQuery.creator_payment_breakdown`.
 * `user_id` is optional -- when given, the resolver looks up that
 * creator's own tax profile to decide whether the item withholds; when
 * omitted, the item defaults to withholding.
 */
export type PaymentPreviewItemInput = {
  amount: MoneyInput;
  userId?: string | null | undefined;
};

/** An enumeration. */
export type WorkOrderPaymentMethodEnum =
  | 'CREDIT'
  | 'DEBIT'
  | 'FREE'
  | 'WALLET';

export type CreatorPaymentBreakdownQueryVariables = Exact<{
  brandId: string;
  items: Array<Types.PaymentPreviewItemInput>;
}>;


export type CreatorPaymentBreakdownQuery = { tax: { __typename: 'TaxQuery', creatorPaymentBreakdown: (
      { __typename: 'PaymentBreakdownType' }
      & PaymentBreakdownFragmentFragment
    ) } };


export const CreatorPaymentBreakdownDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"creatorPaymentBreakdown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"items"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentPreviewItemInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creatorPaymentBreakdown"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}},{"kind":"Argument","name":{"kind":"Name","value":"items"},"value":{"kind":"Variable","name":{"kind":"Name","value":"items"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentBreakdownFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MoneyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentLineFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentLineType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MoneyFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentBreakdownFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentBreakdownType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MoneyFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentLineFragment"}}]}}]}}]} as unknown as DocumentNode<CreatorPaymentBreakdownQuery, CreatorPaymentBreakdownQueryVariables>;